const $$splitComponentImporter = () => import('/home/runner/work/inspecttec-frontend-admin/inspecttec-frontend-admin/src/routes/client/details.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { Permissions } from "@/constants/permissions";
import { requirePermission } from "@/lib/auth/permission-guard";
import type { AssociationModel } from "@/types/api/association";
import type { UpdateClientRequest } from "@/types/api/client";
import type { UserSummary } from "@/types/api/user";
import { createFileRoute } from "@tanstack/react-router";
import * as z from "zod";
export const Route = createFileRoute("/client/details")({
  beforeLoad: args => requirePermission(Permissions.Clients.View, args),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
const clientSchema = z.object({
  clientName: z.string().min(1, "Client Name is required"),
  domainName: z.string().optional(),
  email: z.string().email("Invalid email").optional().or(z.literal("")),
  phone: z.string().optional(),
  website: z.string().url("Invalid URL").optional().or(z.literal("")),
  address1: z.string().optional(),
  address2: z.string().optional(),
  city: z.string().optional(),
  state: z.string().optional(),
  postalCode: z.string().optional(),
  timeZoneId: z.string().min(1, "Time Zone is required"),
  ownerUserId: z.string().min(1, "Owner User ID is required"),
  tenantId: z.string().optional(),
  industryKey: z.string().optional()
  // isActive removed from schema as it's not in update request
});
type ClientFormValues = z.infer<typeof clientSchema>;

/** Sentinel for "no association" (Radix Select items cannot carry ""). */

interface AssociationFieldProps {
  clientId: string;
  /**
   * `undefined` = not returned by `GET /clients/{id}` (Phase 1A gap),
   * `null` = known to be unlinked.
   */
  currentAssociationId?: string | null;
  associations: AssociationModel[];
  /** `system:associations:manage` — what `POST /clients/{id}/associate-with` enforces. */
  canManage: boolean;
}

/**
 * Read-only association with an inline change control wired to
 * `associationService.associateClient` (`POST /clients/{id}/associate-with`,
 * null = unlink).
 */